// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import flatpickr from "flatpickr"
import "chartkick/chart.js"
import "trix"
import "@rails/actiontext"

import { application } from "./controllers/application"
import AutoSubmit from "@stimulus-components/auto-submit"
application.register("auto-submit", AutoSubmit)
